import { render, staticRenderFns } from "./threeCourse.vue?vue&type=template&id=718d3ca1&scoped=true&"
import script from "./threeCourse.vue?vue&type=script&lang=js&"
export * from "./threeCourse.vue?vue&type=script&lang=js&"
import style0 from "./threeCourse.vue?vue&type=style&index=0&id=718d3ca1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718d3ca1",
  null
  
)

export default component.exports